// extracted by mini-css-extract-plugin
module.exports = {"blockCommon":"shopify-settings__blockCommon___3Fpvf","ShopifySettings":"shopify-settings__ShopifySettings___2Y-Sm"};